import script from "./TheToasts.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheToasts.vue?vue&type=script&lang=ts&setup=true"

import "./TheToasts.vue?vue&type=style&index=0&id=49252b57&lang=sass"

const __exports__ = script;

export default __exports__